import { useContext } from 'react';

import { PlaceholderOverrideDispatchContext } from './PlaceholderOverrideDispatchContext';
import type { SetPlaceholderOverride } from './SetPlaceholderOverride';

export const usePlaceholderOverrideDispatch = (): SetPlaceholderOverride => {
	const dispatch = useContext(PlaceholderOverrideDispatchContext);
	if (dispatch === null) {
		throw new Error(
			'usePlaceholderOverrideDispatch must be used within ChatInputPlaceholderOverrideProvider',
		);
	}
	return dispatch;
};
